<template>
    <div :class="teamMemberClass" v-on:click="$emit('filled-out', item.id)">
        <div class="row">
            <div v-if="!isMobile()" class="col col-lg-1 price-column">
                <span v-if="item.price">{{parseFloat(item.price) | toCurrency}}</span>
            </div>
            <div class="col col-lg-9 name-column">
                <div class="step-num" style="font-weight:500;float:left;margin-right:10px">{{initials}}</div>
                <span><strong>{{item.firstName}} {{item.lastName}}</strong></span>
            </div>
            <div v-if="isMobile()" class="col col-lg-1 price-column">
                <span v-if="item.price">{{parseFloat(item.price) | toCurrency}}</span>
            </div>
            <div class="col col-lg-2 button-column"><button
                class="btn-step-select"
                :value="item.id"
                >Select</button></div>
        </div>
    </div>
</template>

<script>
  import VueScreenSize from 'vue-screen-size';
  export default {
    props: {
      item: {},
      value: '',
    },
    mixins: [VueScreenSize.VueScreenSizeMixin],
    methods: {
        isMobile() {
            return this.$vssWidth <= 770;
        }
    },
    computed: {
        getValueId() {
            return this.value ? this.value.id : '';
        },
        teamMemberClass() {
            return {
                "team-member-list-box-item": true,
                "step-fields-list-box-item": true,
                "selected": this.getValueId==this.item.id
            };
        },
        initials() {
            return this.item.firstName.charAt(0) + this.item.lastName.charAt(0);
        }
    }
  };
</script>
<style>
.team-member-list-box-item .col {
    vertical-align: middle;
}
.team-member-list-box-item {
    line-height:50px;
}
@media only screen and (max-width: 770px) {
    .name-column {
        padding-left:0;
    }
    .price-column {
        max-width:30%;
        text-align: right;
    }
    .team-member-list-box-item .button-column {
        max-width:10%;
    }
}
</style>
